export default {
    getList: '/v1/product/listbygroupid',
    getQrcode: '/v1/wechat/wxacodegetUnlimited'
};
